import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from '../../../components/PageLayout/CheckBox';
import PermissionsPanel from '../../../components/PageLayout/Popups/PermissionsPanel';
export default function () {
    function onClick1(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose) {
        handleClose();
    }
    function onChecked2(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex, checked) {
        handlePermissionChange(permission.id, 0);
    }
    function onChecked3(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex, checked) {
        handlePermissionChange(permission.id, 1);
    }
    function onChecked4(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex, checked) {
        handlePermissionChange(permission.id, 2);
    }
    function repeatPermission5(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex) {
        return React.createElement('li', { 'key': permission.id }, React.createElement('div', { 'className': 'fabricators-popup-row' }, React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement(CheckBox, {
            'checked': permission.accessRights === 0,
            'text': 'None',
            'onChecked': onChecked2.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex),
            'type': 'small'
        })), React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement(CheckBox, {
            'checked': permission.accessRights === 1,
            'text': 'Read',
            'onChecked': onChecked3.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex),
            'type': 'small',
            'disabled': permission.enabledLevel < 1
        })), React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement(CheckBox, {
            'checked': permission.accessRights === 2,
            'text': 'Read/Edit',
            'onChecked': onChecked4.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose, permission, permissionIndex),
            'type': 'small',
            'disabled': permission.enabledLevel < 2
        })), React.createElement('div', { 'className': 'fabricators-popup-col' }, React.createElement('div', { 'className': 'fabricators-popup-items-permission-name' }, '\r\n                  ', permission.description, '\r\n                '))));
    }
    function onClick6(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose) {
        handleClose();
    }
    function onClick7(user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose) {
        handleSave();
    }
    function scopeUserPermissionsAllCheckedConcatPermissionsHandlePermissionChangeHandleSaveHandleClose8() {
        var user = this.state.user;
        var permissions = this.state.permissions;
        var allChecked = this.props.allChecked;
        var concatPermissions = this.state.concatPermissions;
        var handlePermissionChange = this.handlePermissionChange;
        var handleSave = this.handleSave;
        var handleClose = this.handleClose;
        return React.createElement('div', {
            'className': 'fabricators-popup-container',
            'key': '205'
        }, React.createElement('div', { 'className': 'ui-popup ui-popup--permissions' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Set permissions for ', user.name), React.createElement('button', {
            'className': 'ui-popup-header__close',
            'onClick': onClick1.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose)
        })), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement(PermissionsPanel, {
            'changeAllPermissions': this.changeAllPermissions,
            'setPermissions': this.setPermissions
        }), React.createElement('div', { 'className': 'permissions' }, React.createElement.apply(this, [
            'ul',
            { 'className': 'ui-list' },
            _.map(permissions.allRights, repeatPermission5.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose))
        ]))), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', { 'className': 'ui-button ui-button--blue' }, React.createElement('span', {
            'className': 'ui-button-text ui-button--uppercase',
            'onClick': onClick6.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose)
        }, 'Cancel')), React.createElement('button', {
            'className': 'ui-button ui-button--green',
            'onClick': onClick7.bind(this, user, permissions, allChecked, concatPermissions, handlePermissionChange, handleSave, handleClose)
        }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save')))));
    }
    return this.state.showPopup ? scopeUserPermissionsAllCheckedConcatPermissionsHandlePermissionChangeHandleSaveHandleClose8.apply(this, []) : null;
}